/**
 * Resolve a marketplace domain for URL/regex template substitution.
 * Strips scheme/path, optional www., and template placeholder prefix.
 */
export function resolveMarketplaceDomain(domain: string): string {
  let d = domain.trim();
  if (!d) {
    return '';
  }

  if (d.includes('://')) {
    try {
      d = new URL(d).hostname;
    } catch {
      d = d.replace(/^https?:\/\//i, '').split('/')[0] ?? '';
    }
  }

  d = d.replace(/^www\./i, '');

  if (/^template\./i.test(d)) {
    d = d.slice('template.'.length);
  }

  return d;
}

/**
 * Host to use when substituting `{domain}` in a pattern.
 * Manual override wins; otherwise uses the definition domain (with template. stripped).
 */
export function domainForPatternSubstitution(
  definitionDomain: string,
  override?: string
): string {
  const trimmedOverride = (override ?? '').trim();
  if (trimmedOverride) {
    return resolveMarketplaceDomain(trimmedOverride);
  }
  return resolveMarketplaceDomain(definitionDomain);
}

/** Replace `{domain}` placeholders in a regex or URL template string. */
export function substituteDomainInPattern(pattern: string, resolvedHost: string): string {
  if (!pattern.includes('{domain}')) {
    return pattern;
  }
  if (!resolvedHost) {
    return pattern;
  }
  return pattern.split('{domain}').join(resolvedHost);
}
